module.exports = __webpack_public_path__ + "static/img/img_ghc_home.846fe77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_ghc_home.png
// module id = 80nW
// module chunks = 1